export const PERIOD_NAMES: Record<string, string> = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
  MANUAL: 'MANUAL',
  ALL: 'ALL',
};

export const PERIOD_LABELS: Record<string, string> = {
  [PERIOD_NAMES.WEEK]: 'Неделя',
  [PERIOD_NAMES.MONTH]: 'Месяц',
  [PERIOD_NAMES.QUARTER]: 'Квартал',
  [PERIOD_NAMES.YEAR]: 'Год',
  [PERIOD_NAMES.MANUAL]: 'Выбрать вручную',
  [PERIOD_NAMES.ALL]: 'За всё время',
};

export const PERIOD_OPTIONS = [
  {value: PERIOD_NAMES.WEEK, label: PERIOD_LABELS.WEEK},
  {value: PERIOD_NAMES.MONTH, label: PERIOD_LABELS.MONTH},
  {value: PERIOD_NAMES.QUARTER, label: PERIOD_LABELS.QUARTER},
  {value: PERIOD_NAMES.YEAR, label: PERIOD_LABELS.YEAR},
  {value: PERIOD_NAMES.MANUAL, label: PERIOD_LABELS.MANUAL},
  {value: PERIOD_NAMES.ALL, label: PERIOD_LABELS.ALL},
] as const;

export const PERIOD_VALUES: Record<string, string> = {
  [PERIOD_NAMES.WEEK]: 'WEEK',
  [PERIOD_NAMES.MONTH]: 'MONTH',
  [PERIOD_NAMES.QUARTER]: 'QUARTER',
  [PERIOD_NAMES.YEAR]: 'YEAR',
  [PERIOD_NAMES.MANUAL]: '',
  [PERIOD_NAMES.ALL]: '',
} as const;

export const WEEK_DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const MONTHS = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
export const QUARTERS = ['1 кв', '2 кв', '3 кв', '4 кв'];
